import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useCookie } from '../hooks';
import { setCookieAccepted } from '../utils/storage';

const style = {
    maxWidth: '700px',
    width: '100%',
    position: 'absolute',
    top: '60px',
    left: '50%',
    transform: 'translate(-50%, 0)',
}

const DismissView = (props) => {
    const [, setCookie] = useCookie();
    const { isOpen, toggle, header, body } = props;

    const handleClick = () => {
        toggle(false);
        setCookie(true);
        setCookieAccepted();
    }

    return (<Modal isOpen={isOpen} toggle={toggle} style={style}>
        <ModalHeader>{header}</ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={handleClick}>
                Accept
            </Button>
        </ModalFooter>
    </Modal>);
}

export default DismissView;